<template lang="pug">
div
  v-dialog(v-model="dialog", persistent, max-width="800px")
    div
      .dialogHeader
        .dialogHeaderTitle(v-if="currentStep === 'selection'") Gerenciar Plantões de {{ userName }}
        .dialogHeaderTitle(v-if="currentStep === 'passing'") Passar {{ selectedShifts.length }} {{ selectedShifts.length === 1 ? 'Plantão' : 'Plantões' }}
        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close")

      .dialogBody
        .dialogBodyContent
          div(v-if="currentStep === 'selection'")
            v-row
              v-col(cols="12", sm="6")
                .createTurnField
                  sos-select(
                    label="Mês",
                    :items="selectMonths",
                    @sosSelectChanged="selectedMonth",
                    :default="currentMonth",
                    :disabled="loading"
                  )
              v-col(cols="12", sm="6")
                .createTurnField
                  sos-select(
                    label="Ano",
                    :items="selectYears",
                    @sosSelectChanged="selectedYear",
                    :default="currentYear",
                    :disabled="loading"
                  )
            v-divider.my-4
            .d-flex.justify-space-between.align-center.mb-2
              h4.mb-2 Plantões para selecionar:
              v-btn(v-if="shifts.length > 0", small, text, @click="toggleSelectAll", color="primary") {{ areAllShiftsSelected ? 'Desmarcar Todos' : 'Selecionar Todos' }}
            v-progress-linear(v-if="loading", indeterminate, color="primary")

            .empty-state.pa-4(v-if="!loading && shifts.length === 0") Nenhum plantão encontrado para este período.

            .duty-cards-container(v-if="!loading && shifts.length > 0")
              .duty-card(
                v-for="duty in shifts",
                :key="duty.plantaoID",
                @click="toggleSelection(duty.plantaoID)",
                :class="{ selected: isSelected(duty.plantaoID) }",
                :style="{ 'background-color': duty.duty.cor_assumido || '#f39c12' }"
              )
                .duty-card__checkbox(v-if="isSelected(duty.plantaoID)")
                  v-icon(color="white", size="20") mdi-check-circle
                .duty-card__main
                  .duty-card__day
                    .day-name {{ duty.dutyDayOfWeek }}
                    .day-number {{ duty.dutyDay }}
                  .duty-card__info
                    .info-item Início: {{ duty.dutyTime }}
                    .info-item Duração: {{ duty.dutyDuration }}
                .duty-card__footer
                  .duty-name {{ duty.duty.nome }}
                  .duty-value {{ formatCurrency(duty.duty.valor) }}

          div(v-if="currentStep === 'passing'")
            p(v-if="!loading") Você está passando
              strong  {{ selectedShifts.length }} {{ selectedShifts.length === 1 ? 'plantão' : 'plantões' }}.
              br
              | Escolha para quem deseja passar:

            .userList(v-if="!loading")


            .searchBlock.mt-4.mb-3(v-if="!loading")
              v-icon.searchFieldIcon(size="18") mdi-magnify
              input.searchField(
                type="text",
                v-model="searchUserText",
                placeholder="Pesquisar por nome ou e-mail",
                :disabled="availableTargetUsers.length < 2"
              )

            v-progress-linear(v-if="loading", indeterminate, color="primary")

            .user-list(v-if="!loading")

              div(
                v-for="userItem in filteredUsers",
                :key="userItem.uid",
                :class="{ 'available-user-item': userItem.uid === '0' }"
              )
                scale-user-list-item(
                  :source="userItem",
                  :click="onUserSelected"
                )

              .empty-state.pa-4(v-if="!loading && filteredUsers.length === 0") Nenhum usuário encontrado com esse termo.


          .text-right.mt-5
            template(v-if="currentStep === 'selection'")
              sos-button.mr-3(
                @buttonClick="close",
                size="medium",
                buttonLabel="Cancelar",
                buttonIcon="mdi-close",
                color="grey",
                :disabled="loading"
              )
              sos-button.mr-3(
                @buttonClick="promptDelete",
                size="medium",
                buttonLabel="Apagar",
                buttonIcon="mdi-delete",
                color="red",
                :disabled="loading || selectedShifts.length === 0"
              )
              sos-button(
                @buttonClick="goToPassStep",
                size="medium",
                buttonLabel="Passar",
                buttonIcon="mdi-arrow-right",
                color="success",
                :disabled="loading || selectedShifts.length === 0"
              )

            template(v-if="currentStep === 'passing'")
              sos-button(
                @buttonClick="goBackToSelection",
                size="medium",
                buttonLabel="Voltar",
                buttonIcon="mdi-arrow-left",
                color="blue",
                :disabled="loading"
              )

  confirm-dialog(
    ref="cdConfirmModal",
    :title="cdParameters.title",
    :text="cdParameters.text",
    :buttonPosition="cdParameters.buttonPosition",
    :width="cdParameters.width",
    @close="cdAction"
  )
</template>
<script>
import moment from "moment";
import "moment/locale/pt-br";
import { CHECK_RULE_VIOLATION } from "@/store/working-hours-rules/types";
import { mapActions } from "vuex";
import ScaleUserListItem from "@/components/ScaleUserListItem";
import ConfirmDialog from "@/modals/ConfirmDialog";
import { mapState } from "vuex";
import userProfileAvailable from "@/assets/images/duty-status-available.png";

// Serviços e Funções
import {
  isValidDuty,
  apiGetUserShiftsBetweenTwoDatesRef,
  apiDeleteDuties,
  apiPassDutiesInBatch,
  apiDeleteDutiesInBatch,
} from "@/services/duties";
import { apiRefOpen, apiRefClose } from "@/services/firebase";

// Mixins e Componentes
import { formatFloatToScaleDuration, formatDbTime } from "@/mixins/utils";
import SosSelect from "@/components/SosSelect";
import { canAddUserShift } from "../../../../functions";
import confirmDialogMixin from "@/mixins/cd.mixin.js";

import { durationToMinutes } from "../../../../mixins/utils";
import SosButton from "../../../../components/SosButton.vue";

const selectMonths = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
};

export default {
  name: "PassShiftsModal",

  mixins: [confirmDialogMixin],

  components: {
    "sos-select": SosSelect,
    ScaleUserListItem,
    "confirm-dialog": ConfirmDialog,
    "sos-button": SosButton,
  },

  props: {
    groupUsers: {
      type: Array,
      default: () => [],
    },
    scaleID: {
      type: String,
      default: null,
    },
    groupID: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      dialog: false,
      deleteConfirmationDialog: false,
      loading: false,
      currentStep: "selection",
      userID: null,
      userName: "",
      currentYear: "",
      searchUserText: '',
      currentMonth: "",
      shifts: [],
      dutiesRef: null,
      selectedShifts: [],
      targetUser: null,
      selectMonths: Object.entries(selectMonths).map(([value, text]) => ({
        key: `month_${value}`,
        value: String(value).padStart(2, "0"),
        text: text,
      })),
      confirmationDialog: {
        visible: false,
        title: "",
        text: "",
        onConfirm: () => {},
      },

      cdParameters: {
        title: "",
        text: "",
        buttonPosition: "right",
        width: 400,
      },
      validationFlags: {
        resolvedConflicts: [],
      },
      confirmActionType: null,
    };
  },

  computed: {
    ...mapState({
      userSession: (state) => state.app.userSession,
    }),
    areAllShiftsSelected() {
      if (this.shifts.length === 0) {
        return false;
      }
      return this.selectedShifts.length === this.shifts.length;
    },
    selectYears() {
      const year = moment().get("year");
      return [year - 1, year, year + 1].map((y) => ({
        key: `year_${y}`,
        value: String(y),
        text: String(y),
      }));
    },

    availableTargetUsers() {

      const availableUser = {
        uid: '0',
        nome: 'Disponível',
        email: 'O plantão ficará aberto para o grupo',

        img: userProfileAvailable,
        userImage: userProfileAvailable,


        roles: [],
        tags: [],


        userID: '0',
        userName: 'Tornar Disponível',
        groupUser: 'NO',
        disabled: false,
        divider: false,

      };

      if (!this.groupUsers) {
        return [availableUser];
      }

      const otherUsers = this.groupUsers.filter((user) => user.uid !== this.userID);

      return [availableUser, ...otherUsers];
    },
    filteredUsers() {
      if (!this.searchUserText) {
        return this.availableTargetUsers;
      }

      const searchTerm = this.searchUserText.toLowerCase().trim();

      return this.availableTargetUsers.filter(user => {
        const name = (user.nome || '').toLowerCase();
        const email = (user.email || '').toLowerCase();

        return name.includes(searchTerm) || email.includes(searchTerm);
      });
    }
  },

  methods: {
    ...mapActions({
      checkRuleViolation: CHECK_RULE_VIOLATION,
    }),

    toggleSelectAll() {
      if (this.areAllShiftsSelected) {
        this.selectedShifts = [];
      } else {
        this.selectedShifts = this.shifts.map(duty => duty.plantaoID);
      }
    },

    buildDetailsHtml(details) {
      if (!details) return "";


      const styles = {
        container: `margin-top: 16px; text-align: left;`,
        title: `font-size: 1rem; font-weight: 600; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 2px solid;`,
        titleSuccess: `color: #28a745; border-color: #28a745;`,
        titleSkipped: `color: #dc3545; border-color: #dc3545;`,
        list: `list-style-type: none; padding: 0; margin: 0;`,
        listItem: `display: flex; justify-content: space-between; align-items: center; padding: 10px 12px; margin-bottom: 8px; background-color: #f8f9fa; border-radius: 6px; border: 1px solid #e9ecef;`,
        info: `display: flex; flex-direction: column;`,
        name: `font-weight: 600; color: #343a40;`,
        date: `font-size: 0.85rem; color: #6c757d;`,
        reason: `font-size: 0.85rem; color: #6c757d;`,
        value: `font-weight: 600; color: #007bff; white-space: nowrap; margin-left: 16px;`,
      };

      let html = `<div style="${styles.container}">`;

      // Seção de Sucesso
      if (details.success && details.success.length > 0) {
        html += `<div style="${styles.title} ${styles.titleSuccess}">Processados com Sucesso</div>`;
        html += `<ul style="${styles.list}">`;
        details.success.forEach((item) => {
          const localDuty = this.shifts.find(
            (s) => s.plantaoID === item.dutyId
          );
          const valor = localDuty
            ? this.formatCurrency(localDuty.duty.valor)
            : this.formatCurrency(item.valor);
          const [datePart, _] = item.data.split(" ");

          html += `<li style="${styles.listItem}">
                 <div style="${styles.info}">
                   <span style="${styles.name}">${item.escala}</span>
                   <span style="${styles.datePart}">${datePart}</span>
                   <span style="${styles.time}">${item.hora_inicio}</span>
                 </div>
                 <span style="${styles.value}">${valor}</span>
               </li>`;
        });
        html += `</ul>`;
      }

      // Seção de Ignorados/Falhas
      if (details.skipped && details.skipped.length > 0) {
        html += `<div style="${styles.title} ${styles.titleSkipped}">Ignorados</div>`;
        html += `<ul style="${styles.list}">`;
        details.skipped.forEach((item) => {
          const localDuty = this.shifts.find(
            (s) => s.plantaoID === item.dutyId
          );
          const escala = localDuty
            ? localDuty.duty.nome
            : item.escala || "Plantão";

          html += `<li style="${styles.listItem}">
                 <div style="${styles.info}">
                   <span style="${styles.name}">${escala}</span>
                   <span style="${styles.reason}">${item.reason}</span>
                 </div>
               </li>`;
        });
        html += `</ul>`;
      }

      html += "</div>";
      return html;
    },

    toggleSelection(dutyId) {
      const index = this.selectedShifts.indexOf(dutyId);
      if (index > -1) {
        this.selectedShifts.splice(index, 1);
      } else {
        this.selectedShifts.push(dutyId);
      }
    },
    isSelected(dutyId) {
      return this.selectedShifts.includes(dutyId);
    },
    getDayOfWeek(dateString) {
      return moment(dateString).format("ddd").toUpperCase();
    },
    formatCurrency(value) {
      const numberValue = Number(value) || 0;
      return numberValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    cdAction(response) {
      if (response === false) {
        this.loading = false;
        return;
      }
      if (this.confirmActionType === "delete") {
        this.executeDelete();
      }
      else if (this.confirmActionType === "pass") {
        this.loading = true;
        if(this.targetUser === '0') {
          this.executePassShifts();

        }else {
          const initialFlags = {
            checkRuleViolations: true,
            checkDutyConflicts: true,
          };

          this.checkConflictsAndPass(initialFlags);
        }
      } else if (this.confirmActionType === "pass_conflict") {
        const nextFlags = {
          ...this.validationFlags,
          resolvedConflicts: [
            ...(this.validationFlags.resolvedConflicts || []),
            this.currentConflictPlantaoID,
          ],
        };
        this.checkConflictsAndPass(nextFlags);
      } else if (this.confirmActionType === "show_results") {
        this.close();
      }

      this.confirmActionType = null;
      this.cdParameters = {
        title: "",
        text: "",
        buttonPosition: "right",
        width: 400,
      };
    },

    async onUserSelected(selectedUser) {
      this.promptPass(selectedUser);
      // this.targetUser = selectedUser.uid;
      // this.loading = true;

      // const initialFlags = {
      //   checkRuleViolations: true,
      //   checkDutyConflicts: true,
      // };

      // await this.checkConflictsAndPass(initialFlags);
    },

    open(userID, userName, month, year) {
      moment.locale("pt-BR");
      this.userID = userID;
      this.userName = userName;
      this.currentMonth = month;
      this.currentYear = year;

      this.resetState();
      this.dialog = true;
      this.fetchShifts();
    },

    close() {
      this.dialog = false;
      this.detachListener();
      this.resetState();
    },

    resetState() {
      this.searchUserText = '';
      this.loading = false;
      this.currentStep = "selection";
      this.shifts = [];
      this.selectedShifts = [];
      this.targetUser = null;
    },

    detachListener() {
      if (this.dutiesRef) {
        apiRefClose(this.dutiesRef, this.onDutiesUpdate);
        this.dutiesRef = null;
      }
    },

    selectedMonth(month) {
      this.currentMonth = month;
      this.fetchShifts();
    },

    selectedYear(year) {
      this.currentYear = year;
      this.fetchShifts();
    },

    fetchShifts() {
      this.detachListener();
      this.loading = true;
      this.shifts = [];
      this.selectedShifts = [];
      const year = Number(this.currentYear);
      const month = Number(this.currentMonth) - 1;
      const firstDate = moment.utc([year, month, 1]).startOf("day");
      const lastDate = moment.utc([year, month, 1]).endOf("month");
      this.dutiesRef = apiGetUserShiftsBetweenTwoDatesRef(
        this.userID,
        firstDate,
        lastDate
      );
      apiRefOpen(this.dutiesRef, this.onDutiesUpdate);
    },

    onDutiesUpdate(snapshot) {
      try {
        const duties = snapshot.val() || {};
        const plantoes = Object.keys(duties)
          .map((dutyID) => {
            const duty = duties[dutyID];
            if (
              !isValidDuty(duty) ||
              duty.uid_pegou !== this.userID ||
              duty.type === "vacation" ||
              duty.type === "day_off" ||
              duty.start_location
            ) {
              return false;
            }
            const tz = duty.dutyStartDateTZ || "";
            const dutyStartDate =
              tz === "+0000"
                ? moment.utc(duty.data_inicio)
                : moment(duty.data_inicio);
            const dutyDay = dutyStartDate.format("DD");
            const dutyDayOfWeek = dutyStartDate.format("ddd").toUpperCase();

            return {
              plantaoID: dutyID,
              dutyDay: dutyDay,
              dutyDayOfWeek: dutyDayOfWeek,
              dutyTime: duty.hora_inicio,
              dutyDuration: formatFloatToScaleDuration(duty.periodo),
              duty: { plantaoID: dutyID, ...duty },
              dutyDate: duty.data_inicio,
              dutyTime: duty.hora_inicio,
              sortDuration: durationToMinutes(formatDbTime(duty.periodo)),
            };
          })
          .filter(Boolean);

        plantoes.sort((a, b) => {
          const tza = a.dutyStartDateTZ || "";
          const tzb = b.dutyStartDateTZ || "";

          const aDataInicio = (
            tza === "+0000" ? moment.utc(a.dutyDate) : moment(a.dutyDate)
          ).format("YYYY-MM-DD");
          const bDataInicio = (
            tzb === "+0000" ? moment.utc(b.dutyDate) : moment(b.dutyDate)
          ).format("YYYY-MM-DD");

          const ad = moment(
            `${aDataInicio} ${a.dutyTime}:00`,
            "YYYY-MM-DD HH:mm:ss"
          ).unix();
          const bd = moment(
            `${bDataInicio} ${b.dutyTime}:00`,
            "YYYY-MM-DD HH:mm:ss"
          ).unix();

          // Secondary sort by duration
          if (`${aDataInicio} ${a.dutyTime}` === `${bDataInicio} ${b.dutyTime}`)
            return a.sortDuration - b.sortDuration;

          // Primary sort by start time
          return ad - bd;
        });
        this.shifts = plantoes;
      } catch (error) {
        console.error("Ocorreu um erro ao processar os plantões:", error);
      } finally {
        this.loading = false;
      }
    },

    goToPassStep() {
      this.currentStep = "passing";
    },

    goBackToSelection() {
      this.currentStep = "selection";
    },

    promptDelete() {
      this.confirmActionType = "delete";
      this.showDialog(
        "Atenção!",
        `${this.selectedShifts.length} ${this.selectedShifts.length === 1 ? 'plantão' : 'plantões'} serão <b style="color: orangered">apagados permanentemente</b> do sistema e dos relatórios.<br /><br /><b>Deseja continuar?</b>`,
        "delete-duty",
        "",
        false,
        "center",
        400
      );
    },

    promptPass(selectedUser) {
      this.targetUser = selectedUser.uid;
      this.confirmActionType = "pass";

      const shiftCount = this.selectedShifts.length;
      const shiftText = shiftCount === 1 ? 'plantão' : 'plantões';

      let title = "Confirmar Ação";
      let text = "";

      if (selectedUser.uid === '0') {
        title = "Tornar Disponível";
        text = `Você tem certeza que deseja tornar <b>${shiftCount} ${shiftText}</b> disponível(eis) para o grupo? <br/><br/>O plantonista atual será removido.`;
      } else {
        const targetUserName = selectedUser.nome || "o usuário selecionado";
        text = `Você tem certeza que deseja passar <b>${shiftCount} ${shiftText}</b> para <b>${targetUserName}</b>?`;
      }

      this.showDialog(
        title,
        text,
        "pass-duty",
        "",
        false,
        "center",
        450
      );
    },

    async executeDelete() {
      this.loading = true;
      try {
        const response = await apiDeleteDutiesInBatch({
          viewerId: this.userSession?.uid,
          dutyIds: this.selectedShifts,
        });

        if (response.code !== "OK") {
          this.showMessage(
            "Erro",
            response.message || "Erro ao apagar plantões."
          );
          throw new Error(response.message || "Erro ao apagar plantões.");
        }
        const detailsHtml = this.buildDetailsHtml(response.details);
        this.confirmActionType = "show_results";
        this.cdParameters = {
          title: response.title || "Resultado da Operação",
          text: `<p>${response.message}</p>${detailsHtml}`,
          buttonPosition: "center",
          width: 600,
          isConfirm: false,
        };
        this.$refs.cdConfirmModal.open({}, false);
      } catch (error) {
        this.showMessage("Erro", error.message || "Erro ao apagar plantões.");
        console.error("Erro ao apagar plantões:", error);
      } finally {
        this.loading = false;
      }
    },

    async checkConflictsAndPass(validationFlags) {
      const targetUserDetails = this.groupUsers.find(
        (u) => u.uid === this.targetUser
      );
      if (!targetUserDetails) {
        this.loading = false;
        return alert("Usuário alvo não encontrado.");
      }

      const selectedYear = Number(this.currentYear);
      const selectedMonth = Number(this.currentMonth) - 1;

      const firstDate = moment
        .utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0])
        .startOf("day");
      const lastDate = moment
        .utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0])
        .endOf("month");

      const conflictsQueue = [];

      for (const plantaoID of this.selectedShifts) {
        if (validationFlags.resolvedConflicts?.includes(plantaoID)) {
          continue;
        }
        const shiftInfo = this.shifts.find((s) => s.plantaoID === plantaoID);
        if (!shiftInfo) continue;
        const { duty } = shiftInfo;
        const dutyDate = moment(duty.data_inicio).format("YYYY-M-D");
        const dutyStartTime = formatDbTime(duty.hora_inicio);

        // Regras de trabalho
        if (validationFlags.checkRuleViolations) {
          const ruleResponse = await this.checkRuleViolation({
            userId: this.targetUser,
            date: dutyDate,
            groupId: this.groupID,
            scaleId: duty.scaleID || this.scaleID,
            turnId: duty.turno,
            duration: duty.periodo,
            start_time: dutyStartTime,
          });

          if (ruleResponse.code === "OK" && ruleResponse.data.violated) {
            const { action, message } = ruleResponse.data;
            const targetUserName = targetUserDetails.nome.split(" ")[0];

            if (action === "block") {
              alert(
                `Ação Bloqueada: ${targetUserName} não pode receber o plantão de ${moment(
                  duty.data_inicio
                ).format("DD/MM/YYYY")}.\nMotivo: ${message}`
              );
              this.loading = false;
              return;
            }

            if (action === "warn") {
              conflictsQueue.push({
                title: "Alerta de violação",
                type: "pass_conflict",
                text: `<div><b>${targetUserName}</b> possui uma violação de regra ao receber o plantão do dia <b>${moment(
                  duty.data_inicio
                ).format(
                  "DD/MM/YYYY"
                )}</b>:</div><br/><div><i>${message}</i></div><br/><div>Deseja continuar mesmo assim?</div>`,
                nextFlags: { ...validationFlags, checkRuleViolations: false },
              });
            }
          }
        }

        // Conflitos de escala
        if (validationFlags.checkDutyConflicts) {
          const { conflictedScales = [], conflictsTableHtml = "" } =
            await canAddUserShift(
              dutyStartTime,
              [moment(duty.data_inicio).format("DD/MM/YYYY")],
              this.targetUser,
              firstDate,
              lastDate
            );

          if (conflictedScales.length > 0) {
            conflictsQueue.push({
              title: "Conflito!",
              type: "pass_conflict",
              text: `<div style="text-align: center">${this.userName} já tem um plantão nesse mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja mudar o plantonista mesmo assim?</b></div>`,
              nextFlags: { ...validationFlags, checkDutyConflicts: false },
            });
          }
        }
      }

      const processConflicts = async (index = 0) => {
        if (index >= conflictsQueue.length) {
          await this.executePassShifts();
          return;
        }

        const conflict = conflictsQueue[index];
        this.confirmActionType = conflict.type;
        this.showConfirmBox({
          title: conflict.title,
          text: conflict.text,
          onConfirm: () => processConflicts(index + 1),
        });
      };

      if (conflictsQueue.length > 0) {
        this.loading = false;
        await processConflicts();
      } else {
        await this.executePassShifts();
      }
    },
    showConfirmation({ title, text, onConfirm }) {
      this.confirmationDialog = {
        visible: true,
        title,
        text,
        onConfirm: () => {
          this.confirmationDialog.visible = false;
          this.loading = true;
          onConfirm();
        },
      };
    },

    async executePassShifts() {
      this.loading = true;
      try {
        const response = await apiPassDutiesInBatch({
          viewerId: this.userSession?.uid,
          dutyIds: this.selectedShifts,
          newOwnerId: this.targetUser,
        });

        if (response.code !== "OK") {
          this.showMessage(
            "Erro",
            response.message || "Erro ao passar plantões."
          );
          throw new Error(response.message || "Erro ao passar plantões.");
        }

        this.confirmActionType = "show_results";
        const detailsHtml = this.buildDetailsHtml(response.details);
        this.cdParameters = {
          title: response.title || "Resultado da Operação",
          text: `<p>${response.message}</p>${detailsHtml}`,
          buttonPosition: "center",
          width: 600,
          isConfirm: false,
        };

        this.$refs.cdConfirmModal.open({}, false);

        this.close();
      } catch (error) {
        console.error("Erro ao passar plantões:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.duty-cards-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px;
  max-height: 38vh;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.duty-card {
  display: flex;
  flex-direction: column;
  width: 160px;
  min-height: 120px;
  padding: 10px;
  border-radius: 12px;
  color: white;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  &.selected {
    outline: 4px solid #007bff;
    outline-offset: -2px;
  }
}

.duty-card__checkbox {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.duty-card__main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-grow: 1;
}

.duty-card__day {
  text-align: center;
  flex-shrink: 0;

  .day-name {
    font-size: 13px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .day-number {
    font-size: 32px;
    font-weight: bold;
    line-height: 1;
  }
}

.duty-card__info {
  font-size: 13px;
  line-height: 1.4;
}

.duty-card__footer {
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  text-align: center;
  width: 100%;

  .duty-name {
    font-weight: bold;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .duty-value {
    font-size: 13px;
  }
}

.dialogBody {
  background-color: #fff;
  max-height: 70vh;
  overflow-y: auto;
}
.dialogBodyContent {
  padding: 25px;
}
.createTurnField {
  padding-bottom: 15px;
}
.empty-state {
  text-align: center;
  color: grey;
  font-style: italic;
  border: 1px dashed #ccc;
  border-radius: 4px;
}
.duty-list,
.user-list {
  max-height: 40vh;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.text-right {
  text-align: right;
}
.mr-3 {
  margin-right: 12px;
}
.mb-2 {
  margin-bottom: 8px;
}
::v-deep .results-container {
  margin-top: 16px;
  text-align: left;
}

::v-deep .results-title {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 2px solid;
  background-color: transparent !important;

  &.success {
    color: #28a745;
    border-color: #28a745;
  }
  &.skipped {
    color: #dc3545;
    border-color: #dc3545;
  }
}

::v-deep .results-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

::v-deep .result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.searchFieldIcon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0 !important;
  left: 12px;
}


.searchBlock {
  position: relative;
  display: block;
  width: 100%;
  // max-width: 320px;
  height: 40px;
  margin-bottom: 16px;
}

.searchField {
  width: 100%;
  // max-width: 320px;
  height: 100%;
  background-color: #ffffff;
  padding: 0 20px 0 40px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  outline: 0;
  // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
  font-size: 15px;
  &:disabled {
    background-color: #CCCCCC;
  }
  margin-bottom: 10px;
}


::v-deep .result-item__info {
  display: flex;
  flex-direction: column;
}

::v-deep .result-item__name {
  font-weight: 600;
  color: #343a40;
}

::v-deep .result-item__date,
::v-deep .result-item__reason {
  font-size: 0.85rem;
  color: #6c757d;
}

::v-deep .result-item__value {
  font-weight: 600;
  color: #007bff;
  white-space: nowrap;
  margin-left: 16px;
}

.available-user-item {
  ::v-deep .newDutyItem {
    background-color: #f0fff4;

    border-left: 3px solid #28a745;

    .item-content span {
      color: #155724 !important;
      font-weight: 600;
    }

    .imgPlaceholder {
      background-color: #28a745;
      color: white;
      font-weight: bold;
    }
  }
}
</style>
